module.exports = require("core-js/modules/es.string.code-point-at");